<template>
  <div class="container mt-1">
    <div class="jumbotron">
      <h1 class="display-4">Welcome to SoWlution!</h1>
      <p class="lead">
        SoWlution is an Arete Internal Application. It is a simple wizard style app for automating the SoW Creation Process.
      </p>
      <hr class="my-4" />
      <h5>SoWlution enables the users to generate and amend SoWs and MSAs.</h5>
      <p>SoWlution Integrates with:
        <ul>
          <li>Mavenlink (Kantata) - Project Data and Law Firms.</li>
          <li>HubSpot - Client Data.</li>
          <li>Rate Card Manager - Rate Chart estimating the Total Cost of SoW.</li>
        </ul>
      </p>
      <div class="mt-5 w-100 d-flex justify-content-center">
        <button class="btn btn-info btn-lg btnLogin" @click="login">
          Login With Your Arete Account
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../Env";

export default {
  name: "Login",
  mounted() {
    const config = {
      auth: {
        clientId: process.env.VUE_APP_clientId,
        authority: process.env.VUE_APP_tenant,
        prompt: "select_account",
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
      },
    };
    this.uaa = new Msal.UserAgentApplication(config);
    this.$root.$emit("init");
  },
  props: {},
  methods: {
    acquireToken: function () {
      let that$ = this;
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(","),
      };
      that$.uaa
        .acquireTokenSilent(loginRequest)
        .then(function (tokenResponse) {
          var token = tokenResponse.accessToken;
          that$.$store.commit("login", token);
          that$.$router.push({ path: "choose-document" });
          that$.$store.commit("user", {
            user: tokenResponse.account,
          });
        })
        .catch(function (error) {
          if (error.name === "InteractionRequiredAuthError") {
            return msalnstance
              .acquireTokenPopup(tokenRequest)
              .then(function (tokenResponse) {
                var token = tokenResponse.accessToken;
                that$.$store.commit("login", token);
                that$.$router.push({ path: "choose-document" });
                that$.$store.commit("user", {
                  user: tokenResponse.account,
                });
                that$.$root.$emit("done");
              })
              .catch((err) => {
                that$.$root.$emit("done");
                // handle error
              });
          } else {
            that$.$root.$emit("done");
          }
        });
    },
    login: function (oEvent) {
      var that = this;
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(","),
      };
      this.$root.$emit("progress");
      this.$store.commit("uaa", that.uaa);
      if (this.uaa.getAccount()) {
        this.acquireToken();
      } else {
        this.uaa
          .loginPopup(loginRequest)
          .then((response) => {
            // handle response
            that.acquireToken();
          })
          .catch((err) => {
            // handle error
            that.$root.$emit("done");
          });
      }
    },
  },
  data() {
    return {
      uaa: {},
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnLogin {
  width: 400px;
  height: 100px;
}
h3 {
  margin: 40px 0 0;
}
a {
  color: #42b983;
}
</style>